export default class ExternalCity {
  name!: string;
  region!: string;
  country!: string;
  country_code!: string;
}
